import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TableManager from "common-ui-components/components/table-manager";
import styles from "./CategorySoftwareList.module.css";
import Select from "common-ui-components/components/select";
import verticalDotMenu from "common-ui-components/components/icons/vertical-dot-menu.svg";
import SideModal from "common-ui-components/components/side-modal/SideModal";
import AffectedDevices from "../device-list/AffectedDevices";
import { notify } from "common-ui-components/components/notification/Notification";
import { Failure } from "common-ui-components/components/notification/templates";
import { PRODUCT_CONTEXT } from "common-ui-components/components/utils/Config";

const isVM=PRODUCT_CONTEXT==="vm"
console.log(isVM)
const CategorySoftwareList = ({ categoryName, preview = false }) => {
  const [tableKey, setTableKey] = useState(0);
  const columns = [
    { title: "Software Name", accessor: "softwareName" },
    { title: "Vendor Name", accessor: "vendorName" },
    { title: "Detected On", accessor: "detectedOn" },
    {
      title: "Affected Systems",
      accessor: "deviceCount",
      WrapperComponent: DeviceOverview,
    },
    {
      title: "Action",
      UIComponent: (props) => (
        <Action {...props} refreshTable={() => setTableKey((k) => k + 1)} />
      ),
      unsearchable: true,
      unsortable: true,
    },
  ];

  return (
    <div className={styles.categoryContent}>
      <TableManager
        key={`${categoryName || "category"}-${tableKey}`}
        columns={columns}
        url={`vulnerabilities/custom-category-software?customCategoryName=${categoryName}`}
        defaultPageSize={preview ? 3 : undefined}
        pageSizeOptions={preview ? [3] : undefined}
        headingText="Total Softwares : "
        contrastRow={false}
        containerProps={{
          className: [
            styles.table,
            preview ? styles.previewTable : "",
          ]
            .filter(Boolean)
            .join(" "),
        }}
        headerProps={{
          style: {
            background: "none",
          },
        }}
        paginationContainerProps={{
          style: {
            background: "none",
          },
        }}
      />
    </div>
  );
};

const Action = ({ record, refreshTable }) => {
  const [sideOpen, setSideOpen] = useState(false);
  const navigate = useNavigate();
  // const options = [
  //   "Uninstall",
  //   // "Add to exceptions",
  //   // "View affected endpoints",
  //   // "Schedule uninstall",
  //   // "Block from network",
  // ];
  // if(!isVM)options.concat("Block from network")
  const options = ["Uninstall", ...(!isVM ? ["Block from network"] : [])];

  const handleOptionSelect = (option) => {
    if (option === "Uninstall") {
      setSideOpen(true);
      return;
    }

    if (option === "Block from network") {
      const rawSoftwareVersionIds =
        record?.softwareVersionIds ??
        record?.softwareVersionId ??
        record?.versionId ??
        record?.id;
      const softwareVersionIds = (
        Array.isArray(rawSoftwareVersionIds)
          ? rawSoftwareVersionIds
          : [rawSoftwareVersionIds]
      ).filter(
        (softwareVersionId) =>
          softwareVersionId !== undefined && softwareVersionId !== null,
      );

      if (!softwareVersionIds.length) {
        notify(<Failure>Software version id is missing.</Failure>);
        return;
      }

      navigate("/app/inventory/application-control/application-group/new", {
        state: {
          osType: "Windows",
          softwareId: softwareVersionIds,
          software: softwareVersionIds.map((softwareVersionId) => ({
              ...record,
              softwareVersionId,
              name: record?.softwareName,
              version: record?.softwareVersion || record?.version,
              manufacturer: record?.vendorName,
          })),
        },
      });
      return;
    }
  };

  return (
    <>
      <Select
        active=""
        options={options}
        triggerComponent={() => (
          <img
            src={verticalDotMenu}
            alt="vertical-dot-menu"
            width={18}
            height={18}
            style={{ cursor: "pointer" }}
          />
        )}
        onOptionSelect={handleOptionSelect}
      />
      <SideModal open={sideOpen} setOpen={setSideOpen}>
        <AffectedDevices
          softwareName={record?.softwareName}
          softwareId={record?.softwareId}
          softwareVersionId={record?.softwareVersionIds}
        />
      </SideModal>
    </>
  );
};

const DeviceOverview = ({ record, children }) => {
  const [sideOpen, setSideOpen] = useState(false);
  return (
    <div>
      <span onClick={() => setSideOpen(true)} className={styles.deviceWrapper}>
        {children}
      </span>
      <SideModal open={sideOpen} setOpen={setSideOpen}>
        <AffectedDevices
          softwareName={record?.softwareName}
          softwareId={record?.softwareId}
          softwareVersionId={record?.softwareVersionIds}
        />
      </SideModal>
    </div>
  );
};

export default CategorySoftwareList;
